import {
  CSSProperties,
  forwardRef,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { throttle } from "lodash";
import styled from "styled-components";
import { MAIN_CONTENT_ID } from "common/constants";

interface StickyHeaderProps {
  style?: CSSProperties;
  children: ReactNode;
}

const StickyHeader = forwardRef<HTMLDivElement, StickyHeaderProps>(
  ({ children, style }, ref) => {
    const [showHeaderShadow, setShowHeaderShadow] = useState(false);

    useEffect(() => {
      const scrollingElement = document.getElementById(MAIN_CONTENT_ID);
      if (!scrollingElement) return;

      const updateHeaderShadow = () => {
        setShowHeaderShadow(
          scrollingElement.scrollTop >= SHOW_SHADOW_SCROLL_THRESHOLD
        );
      };
      const handleScroll = throttle(updateHeaderShadow, 50);

      updateHeaderShadow();
      scrollingElement.addEventListener("scroll", handleScroll);

      return () => {
        scrollingElement.removeEventListener("scroll", handleScroll);
        handleScroll.cancel();
      };
    }, []);

    return (
      <Wrapper $showShadow={showHeaderShadow} ref={ref} style={style}>
        {children}
      </Wrapper>
    );
  }
);

export default StickyHeader;

const SHOW_SHADOW_SCROLL_THRESHOLD = 1;

const Wrapper = styled.div<{ $showShadow: boolean }>`
  position: sticky;
  top: 0;
  background: ${(p) => (p.$showShadow ? p.theme.colors.layoutBgColor : "none")};
  z-index: 2;
  ${(p) =>
    p.$showShadow &&
    `
     box-shadow: ${
       p.theme.isDarkMode ? p.theme.shadows.card : p.theme.shadows.dashboardCard
     };
  `}
`;
